import { z } from 'zod'

/**
 * Where a vendor's reply to a review stands (docs/vendor-growth.spec.md,
 * "Reviews"). Mirrors the Prisma `VendorReviewReplyStatus` enum (`check:enums`).
 *
 * - `pending`: waiting for a platform admin; the company may still change it.
 * - `approved`: published under the review, and fixed from then on.
 * - `declined`: an admin said no, with a reason the company sees; it may be
 *   changed and sent again.
 */
export const VENDOR_REVIEW_REPLY_STATUSES = ['pending', 'approved', 'declined'] as const

export const vendorReviewReplyStatusSchema = z.enum(VENDOR_REVIEW_REPLY_STATUSES)

export type VendorReviewReplyStatus = z.infer<typeof vendorReviewReplyStatusSchema>

/** Still the company's to change and send again: waiting, or declined. An approved reply is fixed. */
export const RESENDABLE_VENDOR_REVIEW_REPLY_STATUSES = ['pending', 'declined'] as const satisfies readonly VendorReviewReplyStatus[]
